import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { getDeviceInfo } from '../../../common/hooks/use-device-info';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import {
  activeChatbotIdSelector,
  selectActiveCompanyId,
} from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { DownloadAppHeaderView } from './DownloadAppHeaderView';
import { DownloadAppHeaderProps } from './types';

export const DownloadAppHeader = (props: DownloadAppHeaderProps) => {
  const { onClick, primaryButtonColor } = props;

  const { isMobile } = getDeviceInfo();

  const dispatch: Dispatch<StoreState> = useDispatch();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const companyId = useSelector(selectActiveCompanyId);
  const {
    id: userId,
    userAttributes: { hideMobileDownload },
  } = useSelector((state: StoreState) => state.session.session);
  const [isHidden, setIsHidden] = useState<boolean>(!!hideMobileDownload);

  const hideBlock = () => {
    setIsHidden(true);
    dispatch(
      usersCRUDActions.updateUserAttributes(companyId, userId, {
        hideMobileDownload: true,
      }),
    );
  };

  const link = `https://app.mobilemonkey.com/chatbot-editor/${chatbotId}/live-chat/null`;

  return (
    <DownloadAppHeaderView
      hideBlock={hideBlock}
      isHidden={!isMobile && isHidden}
      isMobile={isMobile}
      link={link}
      onClick={onClick}
      primaryButtonColor={primaryButtonColor}
    />
  );
};
